module.exports = __webpack_public_path__ + "static/media/example_debug.59cb592e.png";